/**
 * O botão do compositor enquanto o agente trabalha (AB#86889, task 87271), como no Claude Code:
 *
 * - com algo digitado (ou anexado), é sempre **Enviar** — a mensagem entra no que o agente já está
 *   fazendo, e o usuário pode ir acumulando;
 * - com o campo vazio e uma resposta em andamento, é **Parar** o turno;
 * - com o campo vazio e só tarefas em segundo plano, é **Parar** que abre a lista das tarefas,
 *   para cancelar uma a uma;
 * - sem nada rodando, é Enviar (desabilitado enquanto o campo está vazio).
 */
export type ComposerAction = "send" | "stop-turn" | "stop-background";

export function composerAction(state: {
  typing: boolean;
  isResponding: boolean;
  hasBackgroundTasks: boolean;
}): ComposerAction {
  if (state.typing) return "send";
  if (state.isResponding) return "stop-turn";
  if (state.hasBackgroundTasks) return "stop-background";
  return "send";
}
